import { render, staticRenderFns } from "./UpdateFTPModal.vue?vue&type=template&id=4cef9748&scoped=true"
import script from "./UpdateFTPModal.vue?vue&type=script&lang=js"
export * from "./UpdateFTPModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateFTPModal.vue?vue&type=style&index=0&id=4cef9748&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cef9748",
  null
  
)

export default component.exports